import {useGlobalStore} from '../../stores/globalStore';

export const logoutMicrosoft = () => {
    const {resetWithExceptions} = useGlobalStore();
    sessionStorage.clear();
    resetWithExceptions();

    return {name: 'Home'};
};
